export default __webpack_public_path__ + "static/Fig 12 - Transformer & Switchgear Station Detail-919d8436e4e261ebe7ab6bd7f575361c.pdf";